import * as yup from 'yup'
import { useEffect } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { FormArea, FeildWraper, FeildError, FormLabel, SelectSearch } from '../../../../component/form/form-layout'

const AddCategoryForm = ({ onClose = () => { }, onError = () => { }, onSuccess = () => {}, onSubmit = () => { }, currentData, Style }) => {
    const apiCall = useApiCall();
    useEffect(() => {
        if (!currentData?.id) return;

        formik.setValues({
            name: currentData?.name || "",
            status: currentData?.status,
        });
    }, [currentData]);

    const validationSchema = yup.object().shape({
        name: yup.string().required('This Field is required'),
        status: yup.string().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            status: "",
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "category_id": currentData?.id,
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "name": values?.name,
                "status": Number(values?.status),
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `update-supply-category` : `store-supply-category`, data: apiData });
                onSubmit();
                onSuccess(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper width='100%'>
                            <FormLabel required>Category Name</FormLabel>
                            <input
                                type={'text'}
                                name={'name'}
                                onChange={formik.handleChange}
                                value={formik.values.name}
                                placeholder='Category Name'
                            />
                            {formik.touched.name && formik.errors.name && (
                                <FeildError>{formik.errors.name}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Status</FormLabel>

                            <SelectSearch
                                name="status"
                                placeholder="- Select Status -"
                                onChange={(val) => {formik.setFieldValue("status", val);}}
                                value={formik.values.status}
                                options={[
                                    {label: "Active", value: 1},
                                    {label: "In Active", value: 0},
                                ]}
                            />
                            {formik.touched.status && formik.errors.status && (
                                <FeildError>{formik.errors.status}</FeildError>
                            )}
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                    <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                </div>
            </form>
        </>
    )
}

export default AddCategoryForm
